import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Accordion from 'components/global/Accordion';

export const StoreAccordion = styled(Accordion)`
	width: 100%;
	margin-block-end: var(--padding-5);
	.accordion-content-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: var(--padding-3);
	}
`;

export const OTPWrapper = styled.div`
	padding-inline: var(--padding-2);
	display: flex;
	justify-content: flex-end;
`;

export const ConnectButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: var(--padding-4);
`;

export const ConnectedStatus = styled.div`
	display: flex;
	align-items: center;
	gap: var(--padding-2);
`;

export const DisconnectButtonCss = css`
	background-color: var(--red) !important;
	border-color: var(--red) !important;
`;

export const CheckboxContainer = styled.div`
	display: flex;
	align-items: flex-start;
	cursor: pointer;
	gap: 0.7rem;
	user-select: none;

	input[type='checkbox'] {
		min-width: 2rem;
	}

	.credentials-approval {
		color: ${({ hasError }) => (hasError ? 'var(--red)' : 'var(--content-3)')};
	}
`;
